import cn from 'classnames';
import React, { useState } from 'react';
import type { FC } from 'react';
import AnimateHeight from 'react-animate-height';

import Icon, { IconTypes } from 'components/basic/Icon';
import Typograf from 'components/basic/Typograf';
import { BodyL } from 'components/basic/Typography';

import s from './Collapse.module.scss';

interface Props {
  header: string;
  content: JSX.Element;
  className?: string;
}

const Collapse: FC<Props> = ({ header, content, className }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Typograf>
      <div className={cn(s.wrapper, className)}>
        <BodyL
          className={cn(s.header, {
            [s.open]: isOpen,
          })}
          onClick={(): void => setOpen(!isOpen)}
        >
          {header}
          <Icon className={s.icon} icon={IconTypes.expandMore} />
        </BodyL>
        <AnimateHeight duration={200} height={isOpen ? 'auto' : 0}>
          <div className={s.content}>{content}</div>
        </AnimateHeight>
      </div>
    </Typograf>
  );
};

export default Collapse;
